<template>
    <a-config-provider :locale="antdLocale">
        <a-spin :spinning="spinning">
            <!-- 标题 -->
            <div class="modal-header">
                <div class="modal-title">
                    <span>{{ l('import') }}</span>
                </div>
            </div>
            <div class="my-md">
                <a-row class="text">
                    {{'1.' + l('The_Excel_sheet')}}
                </a-row>
                <a-row class="text">
					{{'2.' + l('The_import_file_must_be_in_XSL_ XLSX_format')}}
                </a-row>
                <!-- <a-row class="text">
                    当前周期:<b>{{startTime}}</b>~<b>{{endTime}}</b>
                </a-row> -->
                <a-row class="text">
                    <a-col :span="5">
                        <a-button
                                @click="ExportTemplate()"
                        >
                            <a-icon type="file-excel"/>
                            <span>{{ l("ImportTemplate") }}</span>
                        </a-button>
                    </a-col>
                    <a-col :span="19">
                        <a-upload
                                :action="uploadPictureUrl"
                                :beforeUpload="beforeUpload"
                                :headers="uploadHeaders"
                                @change="uploadPictureChange($event)">
                            <a-button type="primary">
                                <a-icon type="import"/>
                                {{l('import')}}
                            </a-button>
                        </a-upload>
                    </a-col>


                </a-row>
            </div>
        </a-spin>
    </a-config-provider>
</template>

<script>
    import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import ModalComponentBase from "../../../../shared/component-base/modal-component-base";
    import {AppConsts} from "../../../../abpPro/AppConsts";
    import {
        UserPlanImportInput,LayoutUserServiceProxy
    } from "../../../../shared/service-proxies";
    import moment from "moment";
    import {fileDownloadService} from "../../../../shared/utils";

    export default {
        name: "import-excel-model",
        mixins: [ModalComponentBase],
        data() {
            return {
                zh_CN,
                spinning: false,
                uploadPictureUrl: AppConsts.remoteServiceBaseUrl + "/Profile/UploadExcelFile",
                uploadHeaders: {
                    Authorization: "Bearer " + abp.auth.getToken()
                },
                startTime: undefined,
                endTime: undefined
            }
        },
        created() {
            this.fullData();
			this.LayoutUserServiceProxy=new LayoutUserServiceProxy(this.$apiUrl, this.$api);
            this._fileDownloadService = fileDownloadService;
        },
        mounted() {

        },
        methods: {
            beforeUpload(file) {
                let filetype;
                if (file.name) {
                    filetype = file.name.substring(file.name.lastIndexOf('.'));
                }
                let isExcel = filetype === ".xlsx" ||
                    filetype === ".xsl";
                if (!isExcel) {
                    return abp.message.warn(this.l('Only_files_in_XLSX_format_and_XSL_can_be_uploaded'));
                }

            },
            uploadPictureChange({file, fileList}) {
                if (file.status === 'done') {
                    let input = new UserPlanImportInput();
                    input = file.response.result.fileName;
                    this.spinning = true;
                    this.LayoutUserServiceProxy
                        .importExcel(input)
                        .finally(() => {
                            this.spinning = false
                        })
                        .then(res => {
                            if (!res.isSuccess && res.failedCount > 0) {
                                this.$notification["warn"]({
                                    message: this.l('Total_number_of_entries') + ":" + res.totalCount + "  " + this.l('The_number_of_failed_rows') + ":" + res.failedCount,
                                });
                                this._fileDownloadService.downloadTempFile(res.file);
                            } else {
                                this.$notification["success"]({
                                    message: this.l("The_impor_ was_successful"),
                                });
                            }
                        })
                }
            },
            ExportTemplate() {
                this.LayoutUserServiceProxy.getToImportTempFile()
                    .finally(
                        () => {
                        }
                    ).then(
                    res => {
                        this._fileDownloadService.downloadTempFile(res);
                    }
                );
            },
        }
    }
</script>

<style scoped>
    .text {
        padding: 5px 0px;
    }
</style>
